import React, { useEffect, useState, useMemo, useRef } from "react";
import "./ChartSurfaceDark.css";
import "./ChartFilterDark.css";
import "./StackedBarchart.css";
import "./ChartCard.css";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label, Brush } from 'recharts';
// import { StackedBarchartFilter } from "./StackedBarchartFilter";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Button, IconButton, Menu, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import { Tooltip as MaterialTooltip } from "@mui/material";
import { getCallAveragPractice } from "../../../actions/userActions/callAveragePract";
import { getPracticeLocations } from "../../../actions/userActions/practiceLocationAction";
import { getCities } from "../../../actions/userActions/cityAction";
import ApplyButton from "../buttons/ApplyButton";
import ResetButton from "../buttons/ResetButton";
import { Locate, LocateIcon, MapPin, User, CalendarDays, Info, Search, X } from "lucide-react";
import BodyMediumRegular from "../../designSystem/BodyMediumRegular";
import SingleSelect from "../../designSystem/SingleSelect";
import MultiSelect from "../../designSystem/MultiSelect";
import BodySmallRegular from "../../designSystem/BodySmallRegular";
import LineChartTooltip from "./LineChartTooltip";
import LineChartLegend from "./LineChartLegend";
import GranularitySelect from "./GranularitySelect";
import { getSeriesColor } from "./chartPalette";
import {
    DATE_KEY,
    EMPTY_SUMMARY,
    summarise,
    rankSeries,
    bucketByTime,
} from "./chartData";
import useIsDarkTheme from "../../../hooks/useIsDarkTheme";
import { getSubOrdinates } from "../../../actions/userActions/tasks/taskAction";
import { t } from "../../../locales/translate";

const practiceLocationPin = (location) => {
    const lat = location?.latitude ?? location?.Latitude;
    const lng = location?.longitude ?? location?.Longitude;
    if (lat == null || lng == null) return undefined;
    return (
        <MapPin
            size={18}
            color="var(--ff-success)"
            strokeWidth={2.5}
            className="task-practice-location-pin"
            aria-hidden
        />
    );
};

const SHOW_ALL = "all";

export function StackedBarchart({ chartSummaryData, loading, onChangePracticeLocation }) {
    const [appliedFilters, setAppliedFilters] = useState([]);
    const buttonLabels = {
        "today": "Today",
        "this week": "Week",
        "this month": "Month",
        "this year": "Year",
        "custom": `${t("custom")}`,
    };
    function choosefilters(filters) {
        setAppliedFilters(filters);
    }
    const [locationCity, setLocationCity] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [customDate, setCustomDate] = useState(false);
    const [formError, setFormError] = useState({});
    const currentDate = moment();
    const [employeesName, setEmployeesName] = useState([]);
    const practiceLocationName = chartSummaryData.length > 0 ? chartSummaryData[0].practiceLocationName : null;

    // const employees = useSelector((state) => state.employees_reducer.employees);
    const [Filters, setFilters] = useState({
        practiceLocation: 0,
        employeeIds: [],
        fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
        toDate: moment(currentDate).format("YYYY-MM-DD"),
    });
    const [selected, setSelected] = useState({
        practiceLocation: "",
        employeeIds: [],
        fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
        toDate: moment(currentDate).format("YYYY-MM-DD"),
    });
    const setEmployeeNames = (array) => {
        setEmployeesName(array);
    };
    const user = JSON.parse(localStorage.getItem("user"));
    const employeeId =
        user.result[0] !== undefined ? user.result[0].user.id : false
    const practiceLocations = useSelector((state) => state.practiceLocations_reducer?.practiceLocations);
    const practiceLocationsLoading = useSelector((state) => state.practiceLocations_reducer?.loading);
    const cities = useSelector((state) => state.cities_reducer.cities);
    const citiesLoading = useSelector((state) => state.cities_reducer.loading);
    const employees = useSelector((state) => state.tasks_reducer.subOrdinates);
    const employeesLoading = useSelector((state) => state.tasks_reducer.loading);
    useEffect(() => {

        let data = [];
        employees &&
            employees !== "isLoading" &&
            employees.map((row) => {
                appliedFilters.map((row2) => {
                    if (row.id == row2) {
                        data.push(row.firstName + " " + row.lastName);
                    }
                });
            });

        setEmployeeNames(data);
    }, [employees, appliedFilters]);
    const dispatch = useDispatch();
    const [uniqueEmployees, setUniqueEmployees] = useState([]);
    const callAvgPracticeLocation = useSelector(
        (state) => state.call_avg_pract_reducer.callAvgPract
    );
    /* One row per day the API reported, before any bucketing. */
    const [dailyRows, setDailyRows] = useState([]);
    const [summary, setSummary] = useState(EMPTY_SUMMARY);
    const isDark = useIsDarkTheme();
    const [hiddenSeries, setHiddenSeries] = useState([]);
    /* "auto" | "day" | "week" | "month" | "year" */
    const [granularity, setGranularity] = useState("auto");
    const [appliedEmployees, setAppliedEmployees] = useState([]);
    const [appliedPreset, setAppliedPreset] = useState("this week");
    /* The visible window, as indices into the plotted rows. */
    const [zoom, setZoom] = useState(null);

    useEffect(() => {
        const sourceData =
            callAvgPracticeLocation &&
                callAvgPracticeLocation !== "isLoading" &&
                callAvgPracticeLocation.byPracticeLocations &&
                callAvgPracticeLocation.byPracticeLocations.length > 0
                ? callAvgPracticeLocation.byPracticeLocations
                : chartSummaryData || [];

        if (sourceData.length > 0) {
            const uniqueEmployees = [];
            const groupedData = sourceData.reduce((result, item) => {
                const date = moment(item.dateTime).format("D MMM, YY");
                const key = `${date}`;

                if (!result[key]) {
                    result[key] = { date };
                }

                if (!uniqueEmployees.includes(item.employeeName)) {
                    uniqueEmployees.push(item.employeeName);
                }

                result[key][item.employeeName] = (result[key][item.employeeName] || 0) + item.calls;

                return result;
            }, {});

            const employeeNames = new Set();
            Object.values(groupedData).forEach((item) => {
                Object.keys(item).forEach((key) => {
                    if (key !== "date") {
                        employeeNames.add(key);
                    }
                });
            });

            const outputData = Object.values(groupedData).map((item) => {
                const formattedItem = { date: item.date };
                employeeNames.forEach((employeeName) => {
                    formattedItem[employeeName] = item[employeeName] || 0;
                });
                return formattedItem;
            }).sort((a, b) => moment(a.date, "D MMM, YY").toDate() - moment(b.date, "D MMM, YY").toDate());

            const allEmployees = Array.from(employeeNames);
            /* Summarise the raw days first - the strip should report the
               practice location, not the resolution the chart is drawn at. */
            setSummary(summarise(outputData, allEmployees));
            setDailyRows(outputData);
            setUniqueEmployees(rankSeries(outputData, allEmployees));
        } else {
            /* A filter that matches nothing used to leave the previous
               location's chart on screen. */
            setDailyRows([]);
            setUniqueEmployees([]);
            setSummary(EMPTY_SUMMARY);
        }
    }, [callAvgPracticeLocation, chartSummaryData]);

    /* Bucketing is kept out of the fetch effect so switching granularity
       redraws from the rows already in hand instead of refetching. */
    const { rows: data, unit: bucketUnit } = useMemo(
        () =>
            bucketByTime(
                dailyRows,
                uniqueEmployees,
                granularity === "auto" ? null : granularity
            ),
        [dailyRows, uniqueEmployees, granularity]
    );

    /* Colours come from the validated palette and are keyed on the employee
       name, in this chart's own slot registry. */
    const employeeColors = useMemo(
        () =>
            uniqueEmployees.reduce((map, employee) => {
                map[employee] = getSeriesColor(employee, isDark, "employees");
                return map;
            }, {}),
        [uniqueEmployees, isDark]
    );

    const toggleSeries = (employee) => {
        setHiddenSeries((prev) =>
            prev.includes(employee)
                ? prev.filter((item) => item !== employee)
                : [...prev, employee]
        );
    };

    useEffect(() => {
        setHiddenSeries((prev) =>
            prev.filter((employee) => uniqueEmployees.includes(employee))
        );
    }, [uniqueEmployees]);

    /* New rows or a new resolution invalidates both a saved window and an
       earlier "show all". */
    useEffect(() => {
        setZoom((prev) => (prev === null ? prev : null));
    }, [dailyRows, granularity]);
    //

    useEffect(() => {
        const cityBody = {
            "filter": {
                "textSearch": "",
                "countryId": 1
            },
            "pageNumber": -1,
            "pageSize": 0
        }
        if (open) {
            dispatch(getCities(cityBody));
            dispatch(getSubOrdinates(employeeId, -1, 0, ""));
        }

    }, [open]);
    useEffect(() => {
        const practiceLocationBody = {
            filter: {
                textSearch: "",
                city: locationCity
            },
            pageNumber: -1,
            pageSize: 0,
        }
        if (locationCity) {
            dispatch(getPracticeLocations(practiceLocationBody));
        }
    }, [locationCity])
    const handleApply = () => {
        if (validateForm()) {
            const body = {
                practiceLocationFilters: {
                    practiceLocation: Filters.practiceLocation ? Filters.practiceLocation : 0,
                    employeeIds: Filters.employeeIds ? Filters.employeeIds : [0],
                },
                startTime: Filters.fromDate ? Filters.fromDate : new Date().toISOString(),
                endTime: Filters.toDate ? Filters.toDate : new Date().toISOString(),
            };
            onChangePracticeLocation(body)
            dispatch(getCallAveragPractice(body));
            choosefilters(Filters.employeeIds);
            setAppliedEmployees(Filters.employeeIds || []);
            setAppliedPreset(selectedButton);
            handleClose();
        }
    };

    const handleReset = () => {
        setSelected({
            practiceLocation: "",
            employeeIds: [],
            fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
            toDate: moment(currentDate).format("YYYY-MM-DD"),
        });
        setFilters({
            practiceLocation: 0,
            employeeIds: [],
            fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
            toDate: moment(currentDate).format("YYYY-MM-DD"),
        });
        setSelectedButton("this week");
    }
    //
    const validateForm = () => {
        let errors = {};
        let isValid = true;
        if (!Filters.fromDate) {
            errors.fromDate = "From date is required.";
            isValid = false;
        }
        if (!Filters.toDate) {
            errors.toDate = "To date is required.";
            isValid = false;
        }

        setFormError(errors);
        return isValid;
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const [selectedButton, setSelectedButton] = useState("this week");
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event) => {
      const menuPaper = document.querySelector('.MuiMenu-paper, .MuiPopover-paper');
      
      // Don't close if clicking inside any MUI Paper (calendar, picker, dialog, etc.)
      const isInsideMuiPaper = event.target.closest('.MuiPaper-root') !== null;
      if (isInsideMuiPaper) return;
      
      if (menuPaper && !menuPaper.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside, true);
    return () => document.removeEventListener('mousedown', handleClickOutside, true);
  }, [open]);
    const handleToggleSelection = (event, newSelection) => {
        if (newSelection === "this week") {
            setCustomDate(false);
            const fromDate = moment().startOf("week").format("YYYY-MM-DD");
            const toDate = moment().endOf("week").format("YYYY-MM-DD");
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "today") {
            setCustomDate(false);
            const currentDate = moment().format("YYYY-MM-DD");
            setSelected(prevValues => ({ ...prevValues, fromDate: currentDate, toDate: currentDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: currentDate, toDate: currentDate }));
        } else if (newSelection === "yesterday") {
            setCustomDate(false);
            const yesterdayDate = moment().subtract(1, "days").format("YYYY-MM-DD");
            setSelected(prevValues => ({ ...prevValues, fromDate: yesterdayDate, toDate: yesterdayDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: yesterdayDate, toDate: yesterdayDate }));
        } else if (newSelection === "last 30 days") {
            setCustomDate(false);
            const fromDate = moment().subtract(29, "days").toDate();
            const toDate = moment().toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "this month") {
            setCustomDate(false);
            const fromDate = moment().startOf("month").toDate();
            const toDate = moment().endOf("month").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "last month") {
            setCustomDate(false);
            const fromDate = moment().subtract(1, "month").startOf("month").toDate();
            const toDate = moment().subtract(1, "month").endOf("month").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "this year") {
            setCustomDate(false);
            const fromDate = moment().startOf("year").toDate();
            const toDate = moment().endOf("year").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));

        } else if (newSelection === "custom") {
            setCustomDate(true);
            setSelected(prevValues => ({ ...prevValues, fromDate: "", toDate: "" }));
            setFilters(prevValues => ({ ...prevValues, fromDate: "", toDate: "" }));
        }

        setSelectedButton(newSelection);
    };
    const handleLocationChange = (event) => {
        setSelected(prevValues => ({
            ...prevValues,
            practiceLocation: event.value,
        }));

        setFilters(prevValues => ({
            ...prevValues,
            practiceLocation: event.value,
        }));
    };
    const handleEmployeesChange = (selectedEmployees) => {

        setSelected(prevValues => ({
            ...prevValues,
            employeeIds: selectedEmployees,
        }));

        setFilters(prevValues => ({
            ...prevValues,
            employeeIds: selectedEmployees,
        }));
    };

    const handleFromDateChange = (date) => {
        const formattedDate = dayjs(date).format('YYYY-MM-DD');
        setSelected(prevValues => ({
            ...prevValues,
            fromDate: formattedDate,
        }));
        setFilters(prevValues => ({
            ...prevValues,
            fromDate: formattedDate,
        }));
    };
    const handleToDateChange = (date) => {
        const formattedDate = dayjs(date).format('YYYY-MM-DD');
        setSelected(prevValues => ({
            ...prevValues,
            toDate: formattedDate,
        }));
        setFilters(prevValues => ({
            ...prevValues,
            toDate: formattedDate,
        }));
    };
    const handleLocationCityChange = (event) => {
        setLocationCity(event.value);
    };
    const getEmployeeOptions = () => {
        return (
            employees &&
            employees !== "isLoading" &&
            employees.length !== 0 &&
            employees
                .sort((a, b) => {
                    const firstNameComparison = a.firstName.localeCompare(b.firstName);
                    return firstNameComparison !== 0
                        ? firstNameComparison
                        : a.lastName.localeCompare(b.lastName);
                })
                .map((employee) => ({
                    value: employee.id,
                    label: `${employee.firstName} ${employee.lastName}`,
                }))
        ) || [];
    };
    const getOptions = (type) => {
    if (type === "cities") {
        if (citiesLoading || cities === "isLoading") {
            return [{ value: "", label: "Loading...", disabled: true }];
        }
        if (
            cities !== "isLoading" &&
            cities.length !== 0 &&
            cities?.result.length !== 0
        ) {
            return cities?.result
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((city) => ({
                    value: city.id,
                    label: city.name
                }));
        }
        return [];
    }
    if (type === "practiceLocations") {
        if (practiceLocationsLoading || practiceLocations === "isLoading") {
            return [{ value: "", label: "Loading...", disabled: true }];
        }
        if (
            practiceLocations !== "isLoading" &&
            practiceLocations.length !== 0 &&
            practiceLocations.result &&
            practiceLocations.result.length !== 0
        ) {
            return practiceLocations?.result
                ?.sort((a, b) => a.name.localeCompare(b.name))
                .map((location) => {
                    const pin = practiceLocationPin(location);
                    return {
                        value: location.id,
                        label: location.name,
                        ...(pin ? { secondaryLabel: pin } : {}),
                    };
                });
        }
        return [];
    }
}

    /* ---- Card chrome, matching the call-average-by-employee card -------- */

    const isChartLoading = callAvgPracticeLocation === "isLoading" || loading;
    const hasPlottedData = !isChartLoading && data.length > 0;

    const shownLocationName =
        (callAvgPracticeLocation &&
            callAvgPracticeLocation !== "isLoading" &&
            callAvgPracticeLocation.byPracticeLocations?.[0]?.practiceLocationName) ||
        practiceLocationName;

    const rangeLabel = summary.rangeLabel;

    const employeeScopeLabel = appliedEmployees.length
        ? `${appliedEmployees.length} ${t("employees")}`
        : t("allEmployees");

    const hasActiveFilters =
        appliedEmployees.length > 0 || Boolean(Filters.practiceLocation);

    const presetLabel = {
        today: t("today"),
        "this week": t("week"),
        "this month": t("month"),
        "this year": t("year"),
        custom: t("custom"),
    }[appliedPreset];

    const GRANULARITY_OPTIONS = [
        { value: "auto", label: t("auto") },
        { value: "day", label: t("daily") },
        { value: "week", label: t("weekly") },
        { value: "month", label: t("monthly") },
        { value: "year", label: t("yearly") },
    ];
    const unitLabels = {
        day: t("daily"),
        week: t("weekly"),
        month: t("monthly"),
        year: t("yearly"),
    };
    const granularityLabel = unitLabels[bucketUnit] || t("daily");

    const surfaceColor = isDark ? "#1C3041" : "#FFFFFF";

    const legendPayload = uniqueEmployees.map((employee) => ({
        dataKey: employee,
        value: employee,
        color: employeeColors[employee],
    }));

    /* ---- The visible window -------------------------------------------- */

    /* Past about sixty bars each one is a few pixels wide and a re-render
       costs enough that dragging stutters, so a long range opens on its most
       recent stretch. The brush still spans everything. */
    const MAX_COMFORTABLE_BARS = 60;

    const defaultWindow =
        data.length > MAX_COMFORTABLE_BARS
            ? {
                  startIndex: data.length - MAX_COMFORTABLE_BARS,
                  endIndex: data.length - 1,
              }
            : null;

    /* A window is a pair of indices, meaningful only against the rows it was
       taken from, so it carries the resolution and row count it belongs to. */
    const zoomWindow =
        zoom === SHOW_ALL
            ? null
            : zoom && zoom.unit === bucketUnit && zoom.length === data.length
            ? zoom
            : defaultWindow;

    const windowFor = (startIndex, endIndex) => ({
        startIndex,
        endIndex,
        unit: bucketUnit,
        length: data.length,
    });

    const isZoomed = zoomWindow !== null;

    const visibleCount = zoomWindow
        ? zoomWindow.endIndex - zoomWindow.startIndex + 1
        : data.length;

    /* A one-pixel separator eats a two-pixel bar, so it only appears once the
       bars are wide enough to carry it. */
    const barStrokeWidth = visibleCount <= 60 ? 1 : 0;

    /* The drag is deliberately kept out of React state. Every state change
       re-renders this whole component - chips, stats, filter panel and all
       sixty stacked bars - which at ~60ms a frame is what made dragging
       stutter. The selection lives in a ref and is painted by moving one
       absolutely-positioned div, so a drag costs nothing until it is
       committed on release. */
    const dragRef = useRef(null);
    const plotRef = useRef(null);
    const overlayRef = useRef(null);

    const paintOverlay = (fromX, toX) => {
        const overlay = overlayRef.current;
        if (!overlay) return;
        const left = Math.min(fromX, toX);
        overlay.style.left = `${left}px`;
        overlay.style.width = `${Math.abs(toX - fromX)}px`;
    };

    const handleZoomStart = (event) => {
        if (!event || event.activeTooltipIndex == null || event.chartX == null) {
            return;
        }
        dragRef.current = {
            startIndex: event.activeTooltipIndex,
            endIndex: event.activeTooltipIndex,
            startX: event.chartX,
        };
        if (plotRef.current) {
            plotRef.current.classList.add("is-dragging");
        }
        paintOverlay(event.chartX, event.chartX);
    };

    const handleZoomMove = (event) => {
        const drag = dragRef.current;
        if (!drag || !event || event.chartX == null) return;
        if (event.activeTooltipIndex != null) {
            drag.endIndex = event.activeTooltipIndex;
        }
        paintOverlay(drag.startX, event.chartX);
    };

    const endDrag = () => {
        const drag = dragRef.current;
        dragRef.current = null;
        if (plotRef.current) {
            plotRef.current.classList.remove("is-dragging");
        }
        return drag;
    };

    const handleZoomEnd = () => {
        const drag = endDrag();
        if (!drag) return;
        const from = Math.min(drag.startIndex, drag.endIndex);
        const to = Math.max(drag.startIndex, drag.endIndex);
        /* A click is not a drag. */
        if (to - from >= 1) {
            setZoom(windowFor(from, to));
        }
    };

    const resetZoom = () => {
        endDrag();
        setZoom(SHOW_ALL);
    };

    return (
    <div className="chart-container stacked-bar-chart-container overlay-wrapper lc-card">
        <div>      <div>
                <div className="lc-card__header">
                    <div className="lc-card__titles">
                        <div className="lc-card__title-row">
                            <LocateIcon size={18} aria-hidden="true" />
                            <h3 className="lc-card__title">{t("callAverageByPracticeLocation")}</h3>
                            <MaterialTooltip
                                title={`${t("callAveragePracticeHelp")} ${t("dragToZoom")}.`}
                                arrow
                                enterTouchDelay={0}
                                placement="top"
                            >
                                <span className="lc-card__info" tabIndex={0} role="note">
                                    <Info size={14} aria-hidden="true" />
                                </span>
                            </MaterialTooltip>
                        </div>
                        <p className="lc-card__subtitle">{t("callsOverTimeByEmployee")}</p>
                    </div>
                    <div className="lc-card__filter-wrap">
                        <MaterialTooltip title={t("applyFilters")} arrow enterDelay={500} placement="bottom">
                            <button
                                type="button"
                                className={`lc-card__filter-btn${open ? " is-active" : ""}`}
                                onClick={handleClick}
                                aria-label={t("applyFilters")}
                                aria-haspopup="true"
                                aria-expanded={open}
                            >
                                <FilterAltOutlinedIcon fontSize="small" />
                            </button>
                        </MaterialTooltip>
                        {hasActiveFilters && <span className="lc-card__filter-dot" />}
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            PaperProps={{
                                style: {
                                    width: "640px",
                                    borderRadius: "4px",
                                    top: "20% !important",
                                    background: "#FFFFFF",
                                    boxShadow: "0px 11px 15px -7px #00000033",
                                },
                            }}
                        >
                            <div className="row" style={{
                                padding: "16px 24px 0px 24px",
                                justify: "space-between",
                                display: "flex",
                                gap: "24px"
                            }}>
                                <div className="col-12 d-flex ml-2">
                                    <BodyMediumRegular text={t("applyFilters")} />
                                    <MaterialTooltip title="Close Filter" arrow>
                                        <CloseIcon style={{ marginLeft: "auto", cursor: "pointer" }} onClick={handleClose} />
                                    </MaterialTooltip>
                                </div>
                            </div>
                            <div className="row" style={{
                                gap: "24px",
                                borderBottom: "1px solid #0000001F",
                                padding: "4px 16px 0px 16px",
                                alignItems: "center"
                            }}>
                                <div className="row" style={{ gap: "16px" }}>
                                    <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: "48px" }}>
                                        <ToggleButtonGroup
                                            exclusive
                                            value={selectedButton}
                                            onChange={handleToggleSelection}
                                            aria-label="button group"
                                            style={{
                                                width: "100%",
                                                height: "40px",
                                                gap: "12px",
                                                borderRadius: "6px",
                                                padding: "4px 8px",
                                                backgroundColor: "#f9fafb",
                                                display: "flex",
                                                justifyContent: "space-evenly",
                                                alignItems: "center",
                                            }}
                                        >

                                            {["today", "this week", "this month", "this year", "custom"].map((value) => (
                                                <ToggleButton
                                                    key={value}
                                                    value={value}
                                                    style={{
                                                        minWidth: "34px",
                                                        height: "34px",
                                                        padding: "4px 12px",
                                                        borderRadius: "6px",
                                                        textTransform: "none",
                                                        border: "none",
                                                        backgroundColor: selectedButton === value ? "#FFFFFF" : "inherit",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <BodyMediumRegular text={buttonLabels[value]} />
                                                </ToggleButton>
                                            ))}

                                        </ToggleButtonGroup>
                                    </div>
                                    <div className="col-12 d-flex" style={{
                                        height: "56px",
                                    }}>
                                        <div className="col-6">
                                            <div style={{ marginBottom: "6px" }}>
                                                <BodySmallRegular text={t("from")} />
                                            </div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker

                                                    valueType="date"
                                                    value={selected.fromDate && selected.fromDate.length != 0 ? dayjs(selected.fromDate) : null}
                                                    onChange={handleFromDateChange}
                                                    disabled={!customDate}
                                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                                    sx={{
                                                        width: "100%",
                                                        "& .MuiOutlinedInput-root": {
                                                            height: "40px",
                                                            padding: "0",
                                                            boxSizing: "border-box",
                                                            backgroundColor: "transparent",
                                                            border: "1px solid #E0E0E0",
                                                            borderRadius: "60px",
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            height: "32px",
                                                            padding: "0px 8px",
                                                            fontSize: "14px",
                                                        },
                                                        "& .MuiIconButton-root": {
                                                            padding: "20px",
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                            {formError.fromDate && (
                                                <span style={{ color: "red" }}>{formError.fromDate}</span>
                                            )}
                                        </div>
                                        <div className="col-6">
                                            <div style={{ marginBottom: "6px" }}>
                                                <BodySmallRegular text={t("to")} />
                                            </div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                <DatePicker

                                                    valueType="date"
                                                    value={selected.toDate && selected.toDate.length != 0 ? dayjs(selected.toDate) : null}
                                                    onChange={handleToDateChange}
                                                    disabled={!customDate}
                                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                                    sx={{
                                                        width: "100%",
                                                        "& .MuiOutlinedInput-root": {
                                                            height: "40px",
                                                            padding: "0",
                                                            boxSizing: "border-box",
                                                            backgroundColor: "transparent",
                                                            border: "1px solid #E0E0E0",
                                                            borderRadius: "60px",
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            height: "32px",
                                                            padding: "0px 8px",
                                                            fontSize: "14px",
                                                        },
                                                        "& .MuiIconButton-root": {
                                                            padding: "20px",
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                            {formError.toDate && (
                                                <span style={{ color: "red" }}>{formError.toDate}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ gap: "16px" }}>
                                    <div className="col-12 d-flex" >
                                        <div className="col">
                                            <SingleSelect
                                                label={t("city")}
                                                isSearchable
                                                secondaryLabel
                                                error={locationCity.city}
                                                iconEnd
                                                onChange={handleLocationCityChange}
                                                value={locationCity}
                                                placeholder={t("city")}
                                                    options={getOptions("cities")}

                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ gap: "16px" }}>
                                    <div className="col-12 d-flex" >
                                        <div className="col-6">
                                            <SingleSelect
                                                label={t("practiceLocation")}
                                                isSearchable
                                                secondaryLabel
                                                iconEnd

                                                onChange={handleLocationChange}
                                                value={selected.practiceLocation}
                                                placeholder={t("practiceLocation")}
                                                options={getOptions("practiceLocations")}
                                            />

                                        </div>
                                        <div className="col-6">
                                            <MultiSelect
                                                isSearchable
                                                onChange={handleEmployeesChange}
                                                value={selected?.employeeIds || []}
                                                label={t("emoloyee")}
                                                options={getEmployeeOptions()}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mr-4" style={{
                                padding: "16px 24px 16px 24px",
                                gap: "8px",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                flexWrap: "nowrap"
                            }}>
                                <button
                                    type="submit"
                                    className="primary-button"
                                    disabled={false}
                                    onClick={handleApply}
                                    style={{ width: "78px", minWidth: "78px", maxWidth: "78px", flex: "0 0 78px" }}
                                >
                                    <span className="button-content">
                                        <p className="button-text save">{t("apply")}</p>
                                    </span>
                                </button>
                                <button
                                    className="cancel-button"
                                    type="button"
                                    onClick={handleReset}
                                    style={{ width: "88px", minWidth: "88px", maxWidth: "88px", flex: "0 0 88px" }}

                                >
                                    <span className="button-content">
                                        <p className="button-text">{t("reset")}</p>
                                    </span>
                                </button>
                            </div>

                        </Menu>
                    </div>
                </div>

                {/* What is on screen: which location, over which dates,
                    across how many employees. */}
                <div className="lc-scope">
                    {shownLocationName && (
                        <span className="lc-scope__person">
                            <LocateIcon size={15} aria-hidden="true" />
                            {shownLocationName}
                        </span>
                    )}
                    {rangeLabel && (
                        <span className="lc-chip">
                            <CalendarDays aria-hidden="true" />
                            {rangeLabel}
                            {presetLabel && (
                                <span className="lc-chip__preset">{presetLabel}</span>
                            )}
                        </span>
                    )}
                    <span className="lc-chip">
                        <User aria-hidden="true" />
                        {employeeScopeLabel}
                    </span>
                    {hasPlottedData && (
                        <>
                            <GranularitySelect
                                value={granularity}
                                options={GRANULARITY_OPTIONS}
                                resolvedLabel={granularityLabel}
                                autoLabel={t("auto")}
                                ariaLabel={t("granularity")}
                                onChange={setGranularity}
                              />
                        </>
                    )}
                    {isZoomed && (
                        <button
                            type="button"
                            className="lc-chip lc-chip--button lc-chip--active"
                            onClick={resetZoom}
                        >
                            <Search aria-hidden="true" />
                            {t("zoomedIn")}
                            <X className="lc-chip__caret" aria-hidden="true" />
                        </button>
                    )}
                </div>

                {/* Counted off the raw days the API returned. */}
                {hasPlottedData && (
                    <div className="lc-stats">
                        <div className="lc-stat">
                            <span className="lc-stat__value">{summary.totalCalls}</span>
                            <span className="lc-stat__label">{t("totalCalls")}</span>
                        </div>
                        <div className="lc-stat">
                            <span className="lc-stat__value">{summary.activeDays}</span>
                            <span className="lc-stat__label">{t("activeDays")}</span>
                        </div>
                    </div>
                )}
            </div>

            <div className="graph-container">
                {isChartLoading && <div className="lc-skeleton" aria-hidden="true" />}

                {hasPlottedData && (
                    <div className="lc-plot" ref={plotRef}>
                        <div className="lc-drag-overlay" ref={overlayRef} aria-hidden="true" />
                        <ResponsiveContainer width="100%" height="100%">
                            {/* Still a stacked bar chart - only what feeds it
                                changed: contiguous time buckets, palette
                                colours, and a window the reader can narrow. */}
                            <BarChart
                                data={data}
                                margin={{ top: 16, right: 16, left: 0, bottom: 4 }}
                                barCategoryGap={visibleCount > 60 ? "8%" : "30%"}
                                /* Recharts re-renders the chart on every mouse move, throttled to 60fps
                                   by default. A stacked chart with many bars does not need that rate to
                                   feel responsive, and the spare frames matter in a dev build. */
                                throttleDelay={80}
                                onMouseDown={handleZoomStart}
                                onMouseMove={handleZoomMove}
                                onMouseUp={handleZoomEnd}
                                onMouseLeave={handleZoomEnd}
                                style={{ cursor: "crosshair" }}
                            >
                                <CartesianGrid vertical={false} strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="date"
                                    tickLine={false}
                                    tickMargin={8}
                                    axisLine={false}
                                    minTickGap={16}
                                    interval="preserveStartEnd"
                                />
                                {/* The chart had no y axis at all, so a peak of
                                    3 and a peak of 300 looked identical. */}
                                <YAxis
                                    tickLine={false}
                                    axisLine={false}
                                    width={44}
                                    allowDecimals={false}
                                    tickMargin={4}
                                >
                                    <Label
                                        value={t("calls")}
                                        angle={-90}
                                        position="insideLeft"
                                        className="recharts-axis-label"
                                        style={{ textAnchor: "middle" }}
                                    />
                                </YAxis>
                                <Tooltip
                                    content={<LineChartTooltip />}
                                    cursor={{ fill: isDark ? "#91A9BE" : "#1E293B", fillOpacity: 0.06 }}
                                />
                                {uniqueEmployees.map((employee) => (
                                    <Bar
                                        key={employee}
                                        dataKey={employee}
                                        name={employee}
                                        hide={hiddenSeries.includes(employee)}
                                        stackId="a"
                                        /* Flat segments with a hairline in the
                                           surface colour: rounding each one
                                           turns a stack into a column of pills
                                           and hides where one ends. */
                                        radius={0}
                                        stroke={surfaceColor}
                                        strokeWidth={barStrokeWidth}
                                        maxBarSize={44}
                                        fill={employeeColors[employee]}
                                        isAnimationActive={false}
                                    />
                                ))}

                                {data.length > 2 && (
                                    <Brush
                                        dataKey="date"
                                        height={24}
                                        travellerWidth={8}
                                        stroke={isDark ? "#91A9BE" : "#94A3B8"}
                                        fill={isDark ? "#233C52" : "#F9FAFB"}
                                        startIndex={zoomWindow ? zoomWindow.startIndex : undefined}
                                        endIndex={zoomWindow ? zoomWindow.endIndex : undefined}
                                        onChange={(range) => {
                                            if (!range || range.startIndex == null) return;
                                            if (range.endIndex > data.length - 1) return;
                                            setZoom(windowFor(range.startIndex, range.endIndex));
                                        }}
                                    />
                                )}
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                )}

                {hasPlottedData && uniqueEmployees.length > 1 && (
                    <LineChartLegend
                        payload={legendPayload}
                        hidden={hiddenSeries}
                        onToggle={toggleSeries}
                    />
                )}

                {!isChartLoading && data.length === 0 && (
                    <div className="lc-empty">
                        <span className="lc-empty__icon">
                            <LocateIcon size={20} aria-hidden="true" />
                        </span>
                        <p className="lc-empty__title">{t("noCallsTitle")}</p>
                        <p className="lc-empty__hint">{t("noCallsHint")}</p>
                    </div>
                )}
            </div>
        </div>
        </div>
    );
}
